type UndefinedAware<T> = T extends undefined ? undefined : T | undefined;

/**
 * 判定相关功能是否可用，当无法展示时可以展示可选的替代内容
 * @param feat 需要展示的内容
 * @param when 判定条件
 * @param alter 当内容无法展示时的替代内容
 * @returns
 */
export function available<T>(feat: T): T;
export function available<T>(
  feat: T,
  when: (feat: T) => boolean,
): T | undefined;
export function available<T, U = undefined>(
  feat: T,
  when: (feat: T) => boolean,
  alter: U,
): T | U;
export function available<T, U = undefined>(
  feat: T,
  when?: (feat: T) => boolean,
  alter?: U,
): T | UndefinedAware<U> {
  if (when == null) {
    return feat;
  }

  if (typeof when === 'boolean' ? when : when(feat)) {
    return feat;
  }

  return alter as UndefinedAware<U>;
}
